exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1SdDy9Tiayw73YJa4T3mYw{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-decoration:none;width:100%}._2M7CHM4QR9rY5DAwEYVlHr{color:#4a4a4a;margin-bottom:.35714rem;white-space:nowrap}.FqhvakYPpT3rWBnKNTbhx{color:#fff;font-size:.85714rem;letter-spacing:.07143rem;padding:0 .35714rem;text-decoration:none;text-transform:uppercase;white-space:nowrap}.FqhvakYPpT3rWBnKNTbhx:hover{color:#fff}._3PtJdEOtFnO3G-I8vUBcp9{background-color:#74d17f}._3Wa1wAOhSHRAhhs2YjkUFm{background-color:#f7932d}._3O-3QpEHHIPnyJ5UCKLV-4{background-color:#a4a4a4}._1htshbEre9h1QngpXxEzEf{white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"cell": "_1SdDy9Tiayw73YJa4T3mYw",
	"cell_label": "_2M7CHM4QR9rY5DAwEYVlHr",
	"cell_status": "FqhvakYPpT3rWBnKNTbhx",
	"cell_status_new": "_3PtJdEOtFnO3G-I8vUBcp9",
	"cell_status_inprogress": "_3Wa1wAOhSHRAhhs2YjkUFm",
	"cell_status_complete": "_3O-3QpEHHIPnyJ5UCKLV-4",
	"header": "_1htshbEre9h1QngpXxEzEf"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/WritingAssignment/CoreAndCatchUp/style.postcss
// module id = 1844
// module chunks = 0